export default "__VITE_ASSET__CHmmSyju__"